<div class="action-params-info">
  <h4 class="action-params-info__title" [innerHTML]="'SCENARIOS.INFO.BUILD_TITLE' | translate"></h4>
  <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.BUILD_TEXT' | translate"></p>

  <h4 class="action-params-info__title" [innerHTML]="'SCENARIOS.INFO.VARIABLES_TITLE' | translate"></h4>

  <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.VARIABLES_USER' | translate"></p>
  <ul>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_USER_USERNAME' | translate"></li>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_USER_USEREMAIL' | translate"></li>
  </ul>

  <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.VARIABLES_STORE' | translate"></p>
  <ul>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_STORE_ID' | translate"></li>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_STORE_NAME' | translate"></li>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_STORE_ADDRESS' | translate"></li>
  </ul>

  <ng-container *ngIf="shouldShowEventScopedVariables">
    <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT' | translate"></p>
    <ul>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_ID' | translate"></li>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_DATE' | translate"></li>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_TIME' | translate"></li>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_NAME' | translate"></li>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_FREE' | translate"></li>
      <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_EVENT_LIMIT' | translate"></li>
    </ul>
  </ng-container>

  <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.VARIABLES_CHANCE' | translate"></p>
  <ul>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_CHANCE_1' | translate"></li>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_CHANCE_2' | translate"></li>
    <li [innerHTML]="'SCENARIOS.INFO.VARIABLES_CHANCE_ETC' | translate"></li>
  </ul>
  <p class="action-params-info__text" [innerHTML]="'SCENARIOS.INFO.VARIABLES_CHANCE_TEXT' | translate"></p>

  <h4 class="action-params-info__title" [innerHTML]="'SCENARIOS.INFO.EXAMPLES_TITLE' | translate"></h4>
  <p class="action-params-info__text --example" [innerHTML]="'SCENARIOS.INFO.EXAMPLES_TEXT' | translate"></p>
</div>
